export default __webpack_public_path__ + "static/media/Summer_9781843629603.c3b7af20.jpg";